module.exports = __webpack_public_path__ + "media/images/step1-9664e12967175ec95d28250fdc027ce4.png";